import React, { useState } from "react";
import PlacesTopSection from "../PlacesTopSection/PlacesTopSection";
import DiscoverPlaces from "../DiscoverPlaces/DiscoverPlaces";

const Places = () => {
  const [searchQuery, setSearchQuery] = useState({
      location: "",
      restaurantName: ""
  })
  const handleSearchData = (searchData)=> {
    if(Object.keys(searchData).length>0){
      setSearchQuery(searchData);
    }
  }
  return (
    <div>
      <PlacesTopSection handleSearchData={handleSearchData}/>
      <DiscoverPlaces searchQueryData={searchQuery} />
    </div>
  );
};

export default Places;
